import { Box, type ColorProps, Flex, type FlexProps } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { CONTENT_MAX_WIDTH } from '@/components/Worlds/UI/constants'

export default function Container({
  children,
  bg = 'auto',
  maxWidth = CONTENT_MAX_WIDTH,
  pb,
  pt,
  px,
  ...props
}: {
  children: ReactNode
  bg?: ColorProps['color']
  maxWidth?: FlexProps['maxWidth'] | null
  pb?: FlexProps['pb']
  pt?: FlexProps['pt']
  px?: FlexProps['px']
} & FlexProps): JSX.Element {
  const defaultPadding = { base: '16px', md: '24px' }

  return (
    <Flex
      bg={bg}
      width="100%"
      justify="center"
      px={px ?? defaultPadding}
      pt={pt ?? defaultPadding}
      pb={pb ?? defaultPadding}
      {...props}
    >
      <Box width="100%" maxWidth={maxWidth == null ? 'auto' : maxWidth}>
        {children}
      </Box>
    </Flex>
  )
}
